var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',_vm._b({staticClass:"mt-3 mb-n3",attrs:{"dense":"","outlined":"","background-color":_vm.is_comparable()},model:{value:(_vm.vmodel),callback:function ($$v) {_vm.vmodel=$$v},expression:"vmodel"}},'v-text-field',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }